import { AppTextService } from '@fi-shared/app-text';
import {
    Injector,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Output,
    Component,
    OnInit,
    Input,
    EventEmitter,
} from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { FormReportQuestionDetailsAnswerListData } from './fi-form-report-question-details-answer-data';
import { IFormSubmissionEmitter } from '../fi-form-report-question-details.component';
import { IFormReportQuestionAnswer } from '../../../fi-form-report';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-report-question-details-answer',
    template: `
        @if (!isUserDetails) {
          <mat-card class="fi-form-report-card">
            <mat-card-title class="BrandedBackgroundColor small"></mat-card-title>
            <mat-card-content>
              <h3 [innerHTML]="getAnswerValue()"></h3>
              <div class="fi-form-report-item-list-wrapper">
                <fi-items-list [settings]="ListData" [module]="[FiStateNames.Form._name]"></fi-items-list>
              </div>
            </mat-card-content>
          </mat-card>
        }
        `,
    styleUrls: ['../../../fi-form-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiFormReportQuestionDetailsAnswerComponent
    extends ItemsListContainerBase<FormReportQuestionDetailsAnswerListData>
    implements OnInit
{
    @Input() answer: IFormReportQuestionAnswer;

    @Output() showUserReport = new EventEmitter<IFormSubmissionEmitter>();
    isUserDetails: boolean = false;
    FiStateNames = FiStateNames;

    constructor(
        private injector: Injector,
        private appTextService: AppTextService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () =>
                new FormReportQuestionDetailsAnswerListData(this.injector, (data, parentData) => {
                    let selectedSubmissionId: number;
                    let selectedAnswerSetId: number;

                    if (parentData) {
                        selectedSubmissionId = parentData.Id;
                        selectedAnswerSetId = data.Id;
                    } else {
                        selectedSubmissionId = data.Id;
                        selectedAnswerSetId = data.AnswerSets[0].Id;
                    }
                    this.isUserDetails = true;

                    this.showUserReport.emit({
                        selectedSubmissionId: selectedSubmissionId,
                        selectedAnswerSetId: selectedAnswerSetId,
                    });
                }),
            {
                noLocalSearch: true,
                showDelete: false,
            },
        );
    }

    getAnswerValue(): string {
        if (this.answer.AnswerValue) return this.answer.AnswerValue.replace(new RegExp('\r?\n', 'g'), '<br />');
        return this.appTextService.get('form.report_skipped_by');
    }

    protected LoadItems() {
        this.ListData.Data = this.answer.Details;
        return Promise.resolve();
    }

    protected SetItemsCount() {
        let listItemCount = this.answer.Details.length;

        return Promise.resolve(listItemCount);
    }
}
